import { useRouter } from 'next/router'
import React from 'react'

import { persistLocale } from '../functions/persistLocale'

export const LanguageSelector: React.FC = () => {
  const router = useRouter()
  const { pathname, asPath, query } = router

  const switchToLocale = (locale: string) => {
    persistLocale(locale)
    router.push({ pathname, query }, asPath, { locale })
  }

  return (
    <div
      className="language-selector"
      style={{ display: 'flex', justifyContent: 'center' }}
    >
      <button
        onClick={() => switchToLocale('pt')}
        className={`mx-2 ${router.locale === 'pt' ? 'active' : ''}`}
        aria-label="Português"
      >
        <span className="text-2xl">🇧🇷</span>
      </button>
      <button
        onClick={() => switchToLocale('en')}
        className={`mx-2 ${router.locale === 'en' ? 'active' : ''}`}
        aria-label="English"
      >
        <span className="text-2xl">🇺🇸</span>
      </button>
    </div>
  )
}
